module.exports = __webpack_public_path__ + "fbc6495cc65864e3c49a5947cd6e1b0c.svg";